import { Column, PrimaryColumn } from 'typeorm';

import { ApiProperty } from '../../codegen';
import { IsNumber } from '../../validators';
import { BasicEntityWithoutId } from '../basic/basic.entity';

export class DailyRewardProgress extends BasicEntityWithoutId {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @PrimaryColumn('int')
  userId: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  currentStreak: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  lastClaimedDayKey: number;
}
